<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link to="/Seal/ReadMe/Save">
          <el-button type="primary" size="mini">添加印章审批人介绍</el-button>
        </router-link>
      </div>
    </div>
    <el-table border :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="department.name" width="200px" label="所属公司"></el-table-column>
      <el-table-column label="审批说明">
        <template slot-scope="scope">
          <div class="readme-intro-cont" v-html="scope.row.intro"></div>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" v-if="backRole('SM_4')" width="60px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑印章审批人介绍信息" placement="bottom">
            <router-link :to="{ path: '/Seal/ReadMe/Save', query: { depId: scope.row.department.id}}">
              <el-button type="primary" class="h1-edit" icon="el-icon-edit" circle>
              </el-button>
            </router-link>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 新建/编辑印章审批人介绍 -->
    <!-- <div class="pop-room seal-add-pop" v-if="dialogVisible">
      <a href="javascript:;" @click="hideSealPop()" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="所属公司">
              <el-select size="small" class="organization-select" v-model="form.depId" placeholder="请选择所属公司">
                <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="审批人介绍图片">
              <div class="avatar-img" style="text-align:left;">
                <img v-if="form.url" height="170" :src="form.url" />
                <el-upload style="margin-top:0;" class="avatar-upload" :action="uploadUrl"
                  :data="{ name:'' }" :on-success="handleAvatarSuccess" :show-file-list="false">
                  <el-button size="mini" type="primary" :loading="isUpload">上传审批人介绍图片(750*400)</el-button>
                </el-upload>
              </div>
            </el-form-item>

            <el-form-item label="">
              <el-button @click="addSealExample()" class="form-btn" type="success">确认添加印章审批人介绍</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div> -->

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        isUpload: false,
        uploadUrl: axios.defaults.baseURL + '/common/upload',

        noSelectOrganization: true,

        // 添加印章审批人介绍
        // dialogVisible: false,
        // form: {
        //   depId: "",
        //   url: ""
        // },

        organizationListData: [],
        depId: '',
        addMeetingRoomStatus: false,

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.getLists()
    },
    methods: {
      // 上传成功回调
      // handleAvatarSuccess(res, file) {
      //   this.isUpload = false
      //   this.$set(this.form, 'url', res.vo.fileUrl)
      // },
      // // 添加印章审批人介绍
      // startCreate() {
      //   this.dialogVisible = true
      // },

      // 隐藏印章审批人介绍编辑弹窗
      // hideSealPop() {
      //   this.form = {
      //     depId: "",
      //     url: "",
      //   }
      //   this.dialogVisible = false
      // },
      // // 编辑印章审批人介绍
      // editSealExample(row) {
      //   this.form.depId = row.department.id
      //   this.form.url = row.url

      //   this.dialogVisible = true
      // },

      // 删除印章审批人介绍
      // delSeal(row) {
      //   this.$confirm('此操作将永久删除该印章审批人介绍, 此过程不可逆，是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     ajax.post('/seal/del', {
      //       sealId: row.id
      //     }, (res) => {
      //       this.$message.error("删除印章审批人介绍成功")
      //       // 重新获取列表
      //       this.getLists()
      //     })
      //   }).catch(() => {});
      // },

      // addSealExample() {
      //   ajax.post('/seal/approval/example/save', this.form, res => {
      //     this.getLists()
      //     this.dialogVisible = false
      //   })
      // },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        // console.log(this.filterName)
        // if (this.filterName) {
        //   // 筛选出所有符合的数据
        //   this.filterData = []
        //   for (let i = 0; i < this.listData.length; i++) {
        //     let _new = this.listData[i]
        //     if (_new.name.indexOf(this.filterName) != -1) {
        //       this.filterData.push(_new)
        //     }
        //   }
        // } else {

        // }
        this.filterData = this.listData
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/seal/approval/example/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      // 'depId'() {
      //   this.getLists()
      // },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/seal/readme.vue